import { Col, Row } from "reactstrap";
import {
  getAtasan,
  getDivisiStorage,
  getName,
  getUnitKerjaStorage,
  getUser,
} from "../../../Utils/externalFunctions";
import { CheckCircle } from "react-feather";
import { isIndividu } from "../constants";
import SelectionFieldAssessedUnitKerja from "./SelectionFieldAssessedUnitKerja";
import { SelectionField } from "../../../CommonElements";
import LIST_UNIT from "../constants/ListUnit";

const DetailHeader = ({
  data,
  type,
  className,
  updateUnitKerja,
  updateAssessedBy,
}) => {
  const options = data?.unitKerja
    ?.filter(
      (unitKerja) =>
        unitKerja.nama_unit_kerja !== getUnitKerjaStorage() &&
        (getName() === "Dr. Dina Chahyati"
          ? unitKerja.nama_unit_kerja !== "Perpustakaan"
          : true) &&
        LIST_UNIT?.includes(unitKerja.nama_unit_kerja)
    )
    .map((unitKerja) => {
      const savedUnitKerja = new Set(
        data?.asesmenKelompok?.map(item => item.unit_kerja) || []
      );
      const hasCheckmark = savedUnitKerja.has(unitKerja.nama_unit_kerja);
      return {
      id: unitKerja.id_unit_kerja,
      name: `${unitKerja.nama_unit_kerja} ${hasCheckmark ? "(Tersimpan)" : ""}`,
    }});

  return (
    <Col className={className}>
      {isIndividu(type) ? (
        <>
          <Row>
            <Col className={"col-2"}>
              <strong>Nama</strong>
            </Col>
            <Col>: {getName() ?? getUser()}</Col>
          </Row>
          <Row>
            <Col className={"col-2"}>
              <strong>Unit Kerja</strong>
            </Col>
            <Col>: {getDivisiStorage()}</Col>
          </Row>
          <Row>
            <Col className={"col-2"}>
              <strong>Atasan</strong>
            </Col>
            <Col>: {getAtasan() ?? ""}</Col>
          </Row>
        </>
      ) : (
        <>
          <Row>
            <Col className={"col-3"}>
              <strong>Saya mewakili unit kerja</strong>
            </Col>
            <Col>
              <div className="d-flex">
                :{" "}
                <SelectionFieldAssessedUnitKerja
                  updateAssessedBy={updateAssessedBy}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col className={"col-3"}>
              <strong>Unit Kerja</strong>
            </Col>
            <Col>
              <div className="d-flex">
                :{" "}
                <SelectionField
                  className={"m-0 py-0 w-75"}
                  placeholder={"Pilih Unit Kerja"}
                  options={options}
                  onChange={(e) => updateUnitKerja(e.target.value)}
                />
              </div>
            </Col>
          </Row>
        </>
      )}
      <Row>
        <Col className={`${isIndividu(type) ? "col-2" : "col-3"}`}>
          <strong>Periode Penilaian</strong>
        </Col>
        <Col>: Januari - Agustus 2025</Col>
      </Row>
    </Col>
  );
};

export default DetailHeader;
